export class LineGraphOptions {
	legend?: any;
	plugins?: any;
	title?: any;
	tooltips: any;
	[propName: string]: any;
}
